//--------------------------------APP-VERSION-LIST------------------------------------------------
export const SET_APP_VERSION_LIST = "SET_APP_VERSION_LIST";
export const GET_APP_VERSION_PENDING = "GET_APP_VERSION_PENDING";
export const APP_VERSION_LIST_ERROR = "APP_VERSION_LIST_ERROR"
export const CLEAR_APP_VERSION_LIST_ERROR = "CLEAR_APP_VERSION_LIST_ERROR"

//--------------------------------APP-VERSION-CREATE----------------------------------------------
export const ADD_APP_VERSION = "ADD_APP_VERSION"
export const OPEN_CREATE_APP_VERSION_MODAL = "OPEN_CREATE_APP_VERSION_MODAL";
export const CLOSE_CREATE_APP_VERSION_MODAL = "CLOSE_CREATE_APP_VERSION_MODAL";
export const CREATE_APP_VERSION_PENDING = "CREATE_APP_VERSION_PENDING";
export const CREATE_APP_VERSION_ERROR = "CREATE_APP_VERSION_ERROR";
export const CLEAR_CREATE_APP_VERSION_ERROR = "CLEAR_CREATE_APP_VERSION_ERROR";

//--------------------------------APP-VERSION-EDIT------------------------------------------------
export const SET_APP_VERSION_DETAILS = "SET_APP_VERSION_DETAILS";
export const OPEN_UPDATE_APP_VERSION_MODAL = "OPEN_UPDATE_APP_VERSION_MODAL";
export const CLOSE_UPDATE_APP_VERSION_MODAL = "CLOSE_UPDATE_APP_VERSION_MODAL";
export const SET_APP_VERSION_EDIT_FORM = "SET_APP_VERSION_EDIT_FORM";
export const UPDATE_APP_VERSION_PENDING = "UPDATE_APP_VERSION_PENDING";
export const UPDATE_APP_VERSION_SUCCESS = "UPDATE_APP_VERSION_SUCCESS";
export const UPDATE_APP_VERSION_ERROR = "UPDATE_APP_VERSION_ERROR";
export const CLEAR_UPDATE_APP_VERSION_ERROR = "CLEAR_UPDATE_APP_VERSION_ERROR"
